import React, { ReactNode } from "react";
import styled from "@emotion/styled";

import UIcon, { UIconProps } from "../../../lib/icons/untitled_ui/UIcon";
import { Flex, Text } from "../../../styles/utility-components";
import Button from "../button/Button";

type Action = {
  label: string;
  onClick: () => void;
};

type ActionToastWithCustomContent = {
  customContent: ReactNode;
};

type ActionToastWithTitle = {
  title: string;
  subtitle?: string;
};

type SharedProps = {
  icon?: UIconProps;
  primaryAction?: Action;
  secondaryAction?: Action;
};

export type ActionToastProps = SharedProps & (ActionToastWithCustomContent | ActionToastWithTitle);

export default function ActionToast(props: ActionToastProps) {
  const renderContent = () => {
    if ("customContent" in props) {
      return props.customContent;
    }

    return (
      <>
        <Text ellipsis>{props.title}</Text>
        {props.subtitle && <StyledText>&nbsp;{props.subtitle}</StyledText>}
      </>
    );
  };

  return (
    <ToastContainer>
      <ToastContent>
        <UIcon icon="checkCircle" {...props.icon} />
        <TextContainer>{renderContent()}</TextContainer>
        {props.secondaryAction && (
          // This tertiary buttonType is intentional
          <Button buttonType="tertiary" onClick={props.secondaryAction.onClick}>
            {props.secondaryAction.label}
          </Button>
        )}
        {props.primaryAction && (
          <Button buttonType="primary" onClick={props.primaryAction.onClick}>
            {props.primaryAction.label}
          </Button>
        )}
      </ToastContent>
    </ToastContainer>
  );
}

const ToastContainer = styled(Flex)({
  maxWidth: "485px",
  width: "fit-content",
  gap: 16,
});

const ToastContent = styled(Flex)({
  gap: 8,
  alignItems: "center",
  minWidth: 0,
});

const TextContainer = styled(Flex)({
  minWidth: 0,
});

const StyledText = styled(Text)({
  whiteSpace: "nowrap",
});
